import { mergeQueryKeys } from '@lukemorales/query-key-factory';
import { awsQueryKeys } from 'domains/aws/query-keys/aws.query-keys.ts';

export const queryKeysClient = mergeQueryKeys(awsQueryKeys);
